import zappy from '@zappy-ride/library.react.components';
import { ChargingWindow } from './ChargingWindow';
import { ChargingWindowFormatter } from './ChargingWindowFormatter';

export * from './ChargingWindow';

zappy.FactoryInstance.registerComponent(ChargingWindow);
zappy.FactoryInstance.registerComponent(ChargingWindowFormatter);
